module.exports = __webpack_public_path__ + "static/media/de.1a0abb45.svg";